export default __webpack_public_path__ + "static/media/Discord_Logo_White.9a823ca6.svg";